





import { defineComponent } from '@vue/composition-api';

import PanelWithVoteEditor from '@/components/Live/PanelWithVoteEditor.vue';

const Edit = defineComponent({
  components: {
    PanelWithVoteEditor,
  },
  // setup() {},
});

export default Edit;
